export default "__VITE_ASSET__faebdf06__"